export default "__VITE_ASSET__7TaPJsFo__"